module.exports = __webpack_public_path__ + "static/media/deleteDocumentIcon.6634fe41.svg";